export default __webpack_public_path__ + "static/media/google-paly.f902960a.png";